// extracted by mini-css-extract-plugin
export default {"container":"OZasS","link":"rdt2z","dark-bg":"_3FBWM"};